import { Divider, FormControlLabel, Switch } from "@mui/material";
import Footer from "_shared/Footer/Footer";
import CreditCardIcon from "assets/images/icons/components/CreditCardIcon";
import CryptoJS from "crypto-js";
import { useFormik } from "formik";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  setJWT,
  setRequestId,
  set_active_step,
  updateIsLoggedIn,
  updateLoading
} from "redux/actions/commonActions";
import { ReactComponent as NewPolicyIcon } from "../../../../assets/images/icons/icon_new_policy.svg";
import { config as globalConfig } from "../../../../config";
import * as globalUtils from "../../../../helpers/utils";
import * as utils from "../../helpers/utils";
import { getCustomerDetails, sendOTP, verifyOTP } from "../../services";
import PersonalDetailsWrapper, { TabsWrapper } from "./style";
import { ReactComponent as BannerCheckIcon } from "assets/images/icons/check.svg";
import { Accordion, AccordionTab } from "primereact/accordion";

import OtpPage from "_shared/OtpScreen/otpPage";
//import { Captcha } from "primereact";
import { TabPanel, TabView } from "primereact";
import { Toast } from "primereact/toast";
import { useLocation, useParams } from "react-router-dom";
// import { getDriverRegistered } from "services/motorRetailService";
import { toGregorian } from "hijri-converter";
import { useIdleTimer } from "react-idle-timer";
import { LeadGeneratation, RESET_ACTION, updateCustomerDetails } from "redux/actions/motorActions";


const PersonalDetails = (props) => {
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useRef(null);
  const { businessLine } = useParams();
  const [activeIndex, setActiveIndex] = useState(0);
  const [isInternal, setIsInternal] = useState(true);
  const [isIdle, setIsIdle] = useState(false);
  const isUserIdleRef = useRef(false);

  const currentStepIndex = useSelector((state) => state.common.stepper?.activeStep);
  //  const { encryptionKey } = useSelector((state) => state.common);
  const { personalFormDetails } = useSelector((state) => state.motor);
  const [showOTP, setShowOTP] = useState(false);
  const [formData, setFormData] = useState({});
  const [startedTyping, setStartedTyping] = useState({ init: true, typing: false });
  const [isHijri, setIsHijri] = useState(false);
  const [activeIndexBanner, setActiveIndexBanner] = useState(null);

  const onClick = (itemIndex) => {
    let _activeIndex = activeIndexBanner ? [...activeIndexBanner] : [];

    if (_activeIndex.length === 0) {
      _activeIndex.push(itemIndex);
    } else {
      const index = _activeIndex.indexOf(itemIndex);
      if (index === -1) {
        _activeIndex[0] = itemIndex;
      } else {
        _activeIndex.splice(index, 1);
      }
    }

    setActiveIndexBanner(_activeIndex);
  };

  // REBRANDING COLORS
  let businessColor = globalUtils.BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === globalUtils.BUSINESS_LINE_PATHS.BSF)
    businessColor = globalUtils.BUSINESS_LINE_COLORS.BSF;
  else if (businessLine === globalUtils.BUSINESS_LINE_PATHS.STC)
    businessColor = globalUtils.BUSINESS_LINE_COLORS.STC;
  else if (businessLine === globalUtils.BUSINESS_LINE_PATHS.LUCID)
    businessColor = globalUtils.BUSINESS_LINE_COLORS.LUCID;
  else if (businessLine === globalUtils.BUSINESS_LINE_PATHS.SNB)
    businessColor = globalUtils.BUSINESS_LINE_COLORS.SNB;
  else if (businessLine === globalUtils.BUSINESS_LINE_PATHS.ALNAGHI)
    businessColor = globalUtils.BUSINESS_LINE_COLORS.ALNAGHI;

  const muiSwitchColor =
    businessLine === globalUtils.BUSINESS_LINE_PATHS.BSF
      ? "greenBsf"
      : globalUtils.BUSINESS_LINE_PATHS.SNB
      ? "greenSnb"
      : globalUtils.BUSINESS_LINE_PATHS.STC
      ? "purpleStc"
      : "primary";

  const formik = useFormik({
    initialValues: {
      nationalId: "",
      yob: "",
      mob: "",
      dob: "",
      prefixMobile: "+966",
      mobile: "",
      isSME: false,
      crNumber: "",
      isValidCaptcha: false,
    },
    validate: (data) => {
      let errors = {};


      if (!data.nationalId && formik.submitForm) {
        errors.nationalId = t("motor_person.nation_id");
      } else if (!globalUtils.isValidSaudiIDOrIQama(data.nationalId)) {
        errors.nationalId = t("motor_person.nation_id_not");
      }

      if (!data.yob && formik.submitForm) {
        errors.yob = t("motor_person.year_birth");
      }

      if (!data.mob && formik.submitForm) {
        errors.mob = t("motor_person.month_birth");
      }

      if (isHijri && !data.dob && formik.submitForm) {
        errors.dob = t("motor_person.day_birth");
      }

      if (!data.mobile && formik.submitForm) {
        errors.mobile = t("motor_person.mob_require");
      } else if (!globalUtils.isValidSaudiPhoneNumber(data.mobile)) {
        errors.mobile = t("motor_person.mob_not_require");
      }

      if (data.isSME && !data.crNumber) {
        if (!data.crNumber) {
          errors.crNumber = t("motor_person.cr_require");
        } else if (!globalUtils.isNumber(data.crNumber) || data.crNumber.length != 10) {
          errors.crNumber = t("motor_person.cr_not_require");
        }
      }

      return errors;
    },

    onSubmit: (data) => {
      dispatch(LeadGeneratation(false));
      //
      let payload = { ...data };

      if (isHijri) {
        const { gm, gy } = toGregorian(Number(data.yob), Number(data.mob), Number(data.dob));

        payload = {
          ...payload,
          mob: globalUtils.makeSureMonthWithZero(gm.toString()),
          yob: gy.toString(),
        };
      }
      delete payload.dob;

      setFormData({ ...payload });
      window.lmSMTObj.track("personalDetailsNextClicked", {
        productName: "Motor",
        subProductName: "",

      });
      // SEND OTP
      sendOTPHandler(payload);
      dispatch(
        updateCustomerDetails({
          personalDetails: { ...payload },
          customerDetails: {},
        })
      );
    },
  });
  const isEnableHijri = formik?.values?.nationalId.startsWith("1");
  const hijriMonths = [
    { label: t("Motor.hijriMonths.01"), value: "01" },
    { label: t("Motor.hijriMonths.02"), value: "02" },
    { label: t("Motor.hijriMonths.03"), value: "03" },
    { label: t("Motor.hijriMonths.04"), value: "04" },
    { label: t("Motor.hijriMonths.05"), value: "05" },
    { label: t("Motor.hijriMonths.06"), value: "06" },
    { label: t("Motor.hijriMonths.07"), value: "07" },
    { label: t("Motor.hijriMonths.08"), value: "08" },
    { label: t("Motor.hijriMonths.09"), value: "09" },
    { label: t("Motor.hijriMonths.10"), value: "10" },
    { label: t("Motor.hijriMonths.11"), value: "11" },
    { label: t("Motor.hijriMonths.12"), value: "12" },
  ];

  //navigate the user after 10 mint if he is not active ;;
  useIdleTimer({
    timeout: 10 * 60 * 1000, // 10 minutes in milliseconds
    onIdle: () => {
      setIsIdle(true);
      isUserIdleRef.current = true;
    },
    onActive: () => {
      setIsIdle(false);
      isUserIdleRef.current = false;
    },
  });
  const currentLang = i18n.language;
  const dynamicUrl = `https://tawuniya.com/${currentLang}`;

  setTimeout(() => {
    if (isUserIdleRef.current) {
      window.location.href = dynamicUrl;
    }
  }, 10 * 60 * 1000);

  // prefill data from query params
  const params = new URLSearchParams(location.search);
  const encId = params.get("id");
  const encYob = params.get("yob");
  const encMob = params.get("mob");
  const encDob = params.get("dob");
  const encMobile = params.get("mobile");
  const hijri = params.get("hijri");
  const valparam = params.get("valparam");
  const newVal = process.env.REACT_APP_FOREIGN_KEY_MOTOR;
  const lang = params.get("lang");

  useEffect(() => {
    if (valparam === process.env.REACT_APP_MOTOR_ADD_PARAM) {
      if (encId) {
        const id = globalUtils.decryptData(encId, newVal);

        if (id) {
          formik.setFieldValue("nationalId", id);
          // formik.setFieldValue("isValidCaptcha", !!id);
        }
      }
      if (lang) {
        if (lang == "en" || lang == "ar") {
          i18n.changeLanguage(lang);
        } else {
          const langVal = globalUtils.decryptData(lang, newVal);
          i18n.changeLanguage(langVal);
        }
      }
      if (hijri) {
        setIsHijri(hijri == "true" ? true : false);
      }

      if (encYob) {
        const yob = globalUtils.decryptData(encYob, newVal);
        if (yob) {
          formik.setFieldValue("yob", yob);
        }
      }

      if (encDob) {
        const dob = globalUtils.decryptData(encDob, newVal);
        if (dob) {
          formik.setFieldValue("dob", dob);
        }
      }

      if (encMob) {
        const mob = globalUtils.decryptData(encMob, newVal);
        if (mob) {
          formik.setFieldValue("mob", mob);
        }
      }
      if (encMobile) {
        const mobile = globalUtils.decryptData(encMobile, newVal);
        if (mobile) {
          formik.setFieldValue("mobile", mobile);
        }
      }

      if (encId && encYob && encMobile && encMob) {
        setTimeout(() => {
          formik.submitForm();
        }, 1500);
      }

      if (!encId) {
        // for google tagging - when user lands directly on page (not when redirected from landing page)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "view_item",
          ecommerce: {
            funnel_step: "step_0",
            step_name:
              utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.step_name_value +
              "view_item",
            items: [
              {
                item_name:
                  utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.item_name_value,
                item_category: "Motor Insurance",
                item_class: "Individual",
                page_source: "internal_click",
              },
            ],
          },
        });
      }

      dispatch(set_active_step(0));
    } else {
      if (encId) {
        const id = CryptoJS?.AES.decrypt(encId.split(" ")?.join("+"), "")?.toString(
          CryptoJS.enc.Utf8
        );
        if (id) {
          formik.setFieldValue("nationalId", id);
          // formik.setFieldValue("isValidCaptcha", !!id);
        }
      }
      if (lang) {
        if (lang == "en" || lang == "ar") {
          i18n.changeLanguage(lang);
        } else {
          const NewVal = CryptoJS?.AES.decrypt(lang?.split(" ")?.join("+"), "")?.toString(
            CryptoJS.enc.Utf8
          );
          i18n.changeLanguage(NewVal);
        }
      }
      if (hijri) {
        setIsHijri(hijri == "true" ? true : false);
      }

      if (encYob) {
        const yob = CryptoJS.AES.decrypt(encYob?.split(" ")?.join("+"), "")?.toString(
          CryptoJS.enc.Utf8
        );
        if (yob) {
          formik.setFieldValue("yob", yob);
        }
      }

      if (encDob) {
        const dob = CryptoJS.AES.decrypt(encDob?.split(" ")?.join("+"), "")?.toString(
          CryptoJS.enc.Utf8
        );
        if (dob) {
          formik.setFieldValue("dob", dob);
        }
      }

      if (encMob) {
        const mob = CryptoJS.AES.decrypt(encMob?.split(" ")?.join("+"), "")?.toString(
          CryptoJS.enc.Utf8
        );
        if (mob) {
          formik.setFieldValue("mob", mob);
        }
      }
      if (encMobile) {
        const mobile = CryptoJS.AES.decrypt(encMobile?.split(" ").join("+"), "")?.toString(
          CryptoJS.enc.Utf8
        );
        if (mobile) {
          formik.setFieldValue("mobile", mobile);
        }
      }
      if (encId && encYob && encMobile && encMob) {
        setTimeout(() => {
          formik.submitForm();
        }, 1500);
      }
      if (!encId) {
        // for google tagging - when user lands directly on page (not when redirected from landing page)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "view_item",
          ecommerce: {
            funnel_step: "step_0",
            step_name:
              utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.step_name_value +
              "view_item",
            items: [
              {
                item_name:
                  utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.item_name_value,
                item_category: "Motor Insurance",
                item_class: "Individual",
                page_source: "internal_click",
              },
            ],
          },
        });
      }
      dispatch(set_active_step(0));
    }

    if (encId) {
      const id = CryptoJS?.AES.decrypt(encId.split(" ")?.join("+"), "")?.toString(
        CryptoJS.enc.Utf8
      );
      if (id) {
        formik.setFieldValue("nationalId", id);
      }
    }
    if (lang) {
      if (lang == "en" || lang == "ar") {
        i18n.changeLanguage(lang);
      } else {
        const NewVal = CryptoJS?.AES.decrypt(lang?.split(" ")?.join("+"), "")?.toString(
          CryptoJS.enc.Utf8
        );
        i18n.changeLanguage(NewVal);
      }
    }
    if (hijri) {
      setIsHijri(hijri == "true" ? true : false);
    }

    if (encYob) {
      const yob = CryptoJS.AES.decrypt(encYob?.split(" ")?.join("+"), "")?.toString(
        CryptoJS.enc.Utf8
      );
      if (yob) {
        formik.setFieldValue("yob", yob);
      }
    }

    if (encDob) {
      const dob = CryptoJS.AES.decrypt(encDob?.split(" ")?.join("+"), "")?.toString(
        CryptoJS.enc.Utf8
      );
      if (dob) {
        formik.setFieldValue("dob", dob);
      }
    }

    if (encMob) {
      const mob = CryptoJS.AES.decrypt(encMob?.split(" ")?.join("+"), "")?.toString(
        CryptoJS.enc.Utf8
      );
      if (mob) {
        formik.setFieldValue("mob", mob);
      }
    }
    if (encMobile) {
      const mobile = CryptoJS.AES.decrypt(encMobile?.split(" ").join("+"), "")?.toString(
        CryptoJS.enc.Utf8
      );
      if (mobile) {
        formik.setFieldValue("mobile", mobile);
      }
    }
    if (encId && encYob && encMobile && encMob) {
      setTimeout(() => {
        formik.submitForm();
      }, 1500);
    }
    if (!encId) {
      // for google tagging - when user lands directly on page (not when redirected from landing page)
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "view_item",
        ecommerce: {
          funnel_step: "step_0",
          step_name:
            utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.step_name_value +
            "view_item",
          items: [
            {
              item_name:
                utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.item_name_value,
              item_category: "Motor Insurance",
              item_class: "Individual",
              page_source: "internal_click",
            },
          ],
        },
      });
    }
    dispatch(set_active_step(0));

  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encId = params.get("id");
    if (startedTyping.init) {
      setStartedTyping({ typing: false, init: false });
    } else {
      if (!startedTyping.init && !startedTyping.typing && !encId) {
        // for google tagging - when user starts typing
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "select_item",
          ecommerce: {
            funnel_step: "step_1",
            step_name:
              utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.step_name_value +
              "select_item",
            items: [
              {
                item_name:
                  utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.item_name_value,
                item_category: "Motor Insurance",
                item_class: "Individual",
              },
            ],
          },
        });
      }
      setStartedTyping({ typing: true, init: false });
    }
  }, [formik.values.nationalId, formik.values.yob, formik.values.mobile]);

  const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
  };
  const getValueTemplate = (rowData) => {
    return (
      <div className="d-flex justify-content-between">
        <img src={rowData.flag} width="20" alt="flag"/>
        <span>{rowData.label}</span>
      </div>
    );
  };
  const customerDetails = () => {
    dispatch(updateLoading(true));
    getCustomerDetails(formData, businessLine)
      .then((response) => {
        dispatch(updateLoading(false));
        if (response && response.resultCode && response.resultCode !== "S") {
          return toast.current.show({
            severity: "error",
            summary: "Error",
            detail: response.resultMessage,
            life: 6000,
          });
        }
        dispatch(
          updateCustomerDetails({
            personalDetails: { ...formData },
            customerDetails: response,
          })
        );
        dispatch(set_active_step(currentStepIndex + 1));
        dispatch(updateIsLoggedIn(true));

        const params = new URLSearchParams(location.search);
        const encSerialNumber = params.get("serialNumber");

        let mobileNumber = personalFormDetails.mobile;
        if (!mobileNumber.startsWith("+966") && !mobileNumber.startsWith("966"))
          mobileNumber = "966" + personalFormDetails.mobile;
        if (encSerialNumber) {
          navigate(
            Boolean(businessLine)
              ? `/${businessLine}/motor/vehicle-details?serialNumber=${encSerialNumber}`
              : `/vehicle-details?serialNumber=${encSerialNumber}`
          );
        } else {
          navigate(
            Boolean(businessLine)
              ? `/${businessLine}/motor/vehicle-details`
              : `/vehicle-details`
          );
        }
      })
      .catch((e) => {
        setShowOTP(false);
        dispatch(updateLoading(false));
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Something went wrong. Try again!",
          life: 6000,
        });
        // for google tagging - when failed to fetch customer detilas
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "error_displayed",
          error_location:
            utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.item_name_value,
          funnel_step: "step_4",
          error_messages: e?.response?.data?.statusDescritpion || e.message,
        });
      });
  };


  const sendOTPHandler = (data) => {
    dispatch(updateLoading(true));
    sendOTP(formik.values.prefixMobile + formik.values.mobile, formik.values.nationalId)
      .then((response) => {
        if (response?.status === "1") {
          setShowOTP(true);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "otp_landing",
            ecommerce: {
              funnel_step: "step_2",
              step_name:
                utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.step_name_value +
                "otp_landing",
              items: [
                {
                  item_name:
                    utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.item_name_value,
                  item_category: "Motor Insurance",
                  item_class: "Individual",
                },
              ],
            },
          });
          setIsInternal(response?.isInternal);
        } else {
        }
      })
      .catch((err) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "error_displayed",
          error_location:
            utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.item_name_value,
          funnel_step: "step_2",
          error_messages: JSON.stringify(err),
        });
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: err?.response?.data?.statusDescritpion || err.message,
          life: 6000,
        });
      })
      .finally(() => {
        dispatch(updateLoading(false));
      });
  };

  const verifyOTPHandler = (otp) => {
    dispatch(updateLoading(true));
    verifyOTP(
      formik.values.prefixMobile + formik.values.mobile,
      otp,
      formik.values.nationalId,
      isInternal
    )
      .then((response) => {

        if (response?.data?.status == "S" || response?.data?.status == "1") {
          const Authtoken = response.data['authToken']
          const Requestid = response.data['requestId']

          dispatch(setJWT(Authtoken))
          dispatch(setRequestId(Requestid))
          
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "otp_verified",
            ecommerce: {
              funnel_step: "step_3",
              step_name:
                utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.step_name_value +
                "otp_verified",
              items: [
                {
                  item_name:
                    utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.item_name_value,
                  item_category: "Motor Insurance",
                  item_class: "Individual",
                },
              ],
            },
          });
          customerDetails();
        } else {
          toast.current.show({
            severity: "info",

            detail: response?.data?.statusDescritpion,
            life: 6000,
          });
        }
      })
      .catch((e) => {
        dispatch(updateLoading(false));
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: e?.response?.data?.statusDescritpion || e.message,
          life: 6000,
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "error_displayed",
          error_location:
            utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.item_name_value,
          funnel_step: "step_3",
          error_messages: e?.response?.data?.statusDescritpion || e.message,
        });
      })
      .finally((e) => {
        dispatch(updateLoading(false));
      });
  };

  const getYobList = () => {
    return isHijri ? globalUtils.getHijriYearOfBirthList() : globalUtils.getGregYearOfBirthList();
  };
  const tabHeaderIRenew = (options) => {
    return (
      <button type="button" onClick={options.onClick} className={options.className}>
        <i className={businessLine ? `icon_wrapper icon_wrapper-${businessLine}` : "icon_wrapper"}>
          <NewPolicyIcon />
        </i>
        {options.titleElement}
      </button>
    );
  };
  const numbersTemplate = (option, props) => {
    if (option) {
      return <div className="numbers_drop">{option.label}</div>;
    }
    return <span>{props.placeholder}</span>;
  };

  useEffect(() => {
    if (formik.values.nationalId && !formik.values.nationalId.startsWith("1")) {
      setIsHijri(false);
    } else if (!isEnableHijri) {
      setIsHijri(false);
    } else if (isEnableHijri && hijri === "true") {
      setIsHijri(true);
    } else if (formik.values.nationalId && !hijri) {
      setIsHijri(true);
    } else {
      setIsHijri(false);
    }
  }, [formik.values.nationalId, isEnableHijri, hijri]);

  useEffect(() => {
    dispatch(RESET_ACTION());
  }, []);

  return (
    <>
      <Toast ref={toast} />
      <TabsWrapper
        className={`col-md-10 col-xs-12 mx-auto visit-visa-mob  ${
          i18n.language === "ar" ? "ar" : ""
        }`}
      >
        {location?.pathname.startsWith("/stc/") && (
          <div className="STC_banner my-4">
            <div className="content">
              <h2>{t("STC.BANNER_HEADER")}</h2>
              <p>{t("STC.SUB_HEADER")}</p>
            </div>
            <div className="buttons_wrapper">
              <p>{t("STC.LEARN_MORE")}</p>
              <div className="buttons">
                <button
                  className={`btn ${
                    activeIndexBanner && activeIndexBanner.some((index) => index === 0)
                      ? " active"
                      : ""
                  }`}
                  onClick={() => onClick(0)}
                >
                  <p>{t("STC.SHAMEL")}</p>
                  <small>{t("STC.COMPREHENSIVE")}</small>
                </button>
                <button
                  className={`btn ${
                    activeIndexBanner && activeIndexBanner.some((index) => index === 1)
                      ? " active"
                      : ""
                  }`}
                  onClick={() => onClick(1)}
                >
                  <p>{t("STC.SANAD")}</p>
                  <small>{t("STC.THIRD_PARTY")}</small>
                </button>
              </div>
            </div>
            <div className="accordion_wrapper">
              <Accordion
                multiple
                activeIndex={activeIndexBanner}
                onTabChange={(e) => setActiveIndexBanner(e.index)}
              >
                <AccordionTab>
                  <div className="feature">
                    <BannerCheckIcon /> <span className="d-inline-block">{t("STC.FEATURE_1")}</span>
                  </div>
                  <div className="feature">
                    <BannerCheckIcon /> <span className="d-inline-block">{t("STC.FEATURE_2")}</span>
                  </div>
                  <div className="feature">
                    <BannerCheckIcon /> <span className="d-inline-block">{t("STC.FEATURE_3")}</span>
                  </div>
                  <div className="feature">
                    <BannerCheckIcon /> <span className="d-inline-block">{t("STC.FEATURE_4")}</span>
                  </div>
                  <div className="feature">
                    <BannerCheckIcon /> <span className="d-inline-block">{t("STC.FEATURE_5")}</span>
                  </div>
                </AccordionTab>
                <AccordionTab>
                  <div className="feature">
                    <BannerCheckIcon /> <span className="d-inline-block">{t("STC.FEATURE_2")}</span>
                  </div>
                  <div className="feature">
                    <BannerCheckIcon /> <span className="d-inline-block">{t("STC.FEATURE_6")}</span>
                  </div>
                  <div className="feature">
                    <BannerCheckIcon /> <span className="d-inline-block">{t("STC.FEATURE_7")}</span>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
        )}

        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
          <TabPanel header={t("Motor.NEW_POLICY")} headerTemplate={tabHeaderIRenew}>
            <PersonalDetailsWrapper
              className={`col-md-10 col-xs-12 mx-auto visa-form ${
                i18n.language === "ar" ? " ar" : ""
              }`}
            >
              {showOTP && (
                <OtpPage
                  verifyOTP={verifyOTPHandler}
                  sendOTP={sendOTPHandler}
                  closeOTP={() => setShowOTP(false)}
                  mobileNumber={formik.values.prefixMobile + formik.values.mobile}
                  isInternal={isInternal}
                  businessColor={businessColor}
                />
              )}
              <div className="">
                <div className="header">
                  <h5>{t("PERSONAL_DETAIL.HEADING")}</h5>
                  <p>{t("PERSONAL_DETAIL.PLEASE_FILL")}</p>
                </div>
                <Divider />
                <form onSubmit={formik.handleSubmit} className="p-fluid mt-4">
                  <div className="field">
                    <span className=" p-float-label p-input-icon-left">
                      <CreditCardIcon color={businessColor} />
                      <InputText
                        disabled={businessLine === globalUtils.BUSINESS_LINE_PATHS.SNB}
                        maxLength={10}
                        name="nationalId"
                        value={formik.values.nationalId}
                        onChange={formik.handleChange}
                        keyfilter="int"
                        className={classNames({
                          "p-invalid": isFormFieldValid("nationalId"),
                          "fm-tawuniya": true,
                        })}
                      />
                      <label htmlFor="">{t("PERSONAL_DETAIL.NATIONAL_ID")}</label>
                    </span>
                    {getFormErrorMessage("nationalId")}
                  </div>

                  {isEnableHijri && (
                    <div className="row my-1 px-2 py-2 text-white">
                      <FormControlLabel
                        value="start"
                        control={<Switch color={muiSwitchColor} />}
                        label={t("motor_person.hijri")}
                        labelPlacement="start"
                        onChange={(e) => {
                          formik.values.yob = "";
                          formik.values.mob = "";
                          formik.values.dob = "";
                          return setIsHijri(e.target.checked);
                        }}
                        disabled={!isEnableHijri}
                        checked={isHijri}
                      />
                    </div>
                  )}

                  <div className="row">
                    <div className={isHijri ? "col-sm-4" : "col-sm-8"}>
                      <div className="field mt-3">
                        <span className="p-float-label">
                          <Dropdown
                            name="yob"
                            value={formik.values.yob}
                            className={classNames({ "p-invalid": isFormFieldValid("yob") })}
                            onChange={formik.handleChange}
                            options={getYobList()}
                            optionLabel="label"
                            optionValue="value"
                            filter
                            filterBy="label"
                            itemTemplate={numbersTemplate}
                          />
                          <label htmlFor="">{t("PERSONAL_DETAIL.YEAROFBIRTH")}</label>
                        </span>
                        {getFormErrorMessage("yob")}
                      </div>
                    </div>

                    <div className="col-sm-4">
                      <div className="field mt-3">
                        <span className="p-float-label">
                          <Dropdown
                            name="mob"
                            value={formik.values.mob}
                            className={classNames({ "p-invalid": isFormFieldValid("mob") })}
                            onChange={formik.handleChange}
                            options={isHijri ? hijriMonths : globalUtils.months}
                            optionLabel="label"
                            optionValue="value"
                            filter
                            filterBy="label"
                            itemTemplate={numbersTemplate}
                          />
                          <label htmlFor="">{t("PERSONAL_DETAIL.MONTH_BIRTH")}</label>
                        </span>
                        {getFormErrorMessage("mob")}
                      </div>
                    </div>

                    {isHijri && (
                      <div className="col-sm-4">
                        <div className="field mt-3">
                          <span className="p-float-label">
                            <Dropdown
                              name="dob"
                              value={formik.values.dob}
                              className={classNames({ "p-invalid": isFormFieldValid("dob") })}
                              onChange={formik.handleChange}
                              options={globalUtils.hijriDays}
                              optionLabel="label"
                              optionValue="value"
                              filter
                              filterBy="label"
                              itemTemplate={numbersTemplate}
                            />
                            <label htmlFor="">{t("PERSONAL_DETAIL.DAY_BIRTH")}</label>
                          </span>
                          {getFormErrorMessage("dob")}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="field mt-3 phone-input phone-icons position-relative">
                    <span className="p-input-icon-left d-flex" dir="ltr">
                      <Dropdown
                        disabled
                        name="prefixMobile"
                        value={formik.values.prefixMobile}
                        valueTemplate={getValueTemplate}
                        className="keys tele"
                        id="tele"
                        onChange={formik.handleChange}
                        options={globalConfig.phoneKeysList}
                        optionLabel="label"
                        optionValue="value"
                      />
                      <InputText
                        name="mobile"
                        maxLength={9}
                        value={formik.values.mobile}
                        onChange={formik.handleChange}
                        className={classNames({
                          values: true,
                          "p-invalid": isFormFieldValid("mobile"),
                          "fm-tawuniya": true,
                          tele: true,
                        })}
                        id="tele"
                        placeholder="ex: 5xxxxxxxx"
                      />
                    </span>
                    <span className="mobile-placeholder">{t("PERSONAL_DETAIL.MOBILENUMBER")}</span>
                    {getFormErrorMessage("mobile")}
                  </div>
                  <Divider className="mt-3" />
                  <p >{t("motor_person.para_1")}</p>
                </form>
                <div className={`${utils.showMobile() ? "footer-right-mob" : "footer-right"}`}>
                  <Footer
                    totalPriceSar={i18n.t("RIGHTFOOTER.SAR")}
                    showNextBtn={true}
                    nextBtnHandler={formik.submitForm}
                    nextBtnLabel={i18n.t("RIGHTFOOTER.NEXT")}
                    showBackBtn={false}
                  />
                </div>
              </div>
            </PersonalDetailsWrapper>
          </TabPanel>
        </TabView>
      </TabsWrapper>
    </>
  );
};

export default PersonalDetails;
